import { Preset } from "@thenounproject/lingo-core";
import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";

export default createEntityReducer<Preset>(
  "presets",
  () => {},
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action) => {
      const presets = getEntitiesFromAction<Preset>(action, "presets");
      return mergeEntitiesIfChanged(state, presets);
    });
  }
);
